/**
 * Created by karthikeyan.k on 30-11-2018.
 */
export class FeatureConstant {
  public static get LIVEDEALER(): string {
    return 'livedealer';
  }

  public static get LIVECASINO(): string {
    return 'livecasino';
  }

  public static get PRIVATE(): string {
    return 'private';
  }

  public static get PRIVATEFRIENDS(): string {
    return 'privatefriends';
  }

  public static get LIVEDEALER_LANG(): string {
    return 'LANG00128';
  }

  public static get LIVECASINO_LANG(): string {
    return 'LANG00129';
  }

  public static get PRIVATE_LANG(): string {
    return 'LANG00130';
  }

  public static get PRIVATEFRIENDS_LANG(): string {
    return 'LANG00131';
  }

  public static get ALLGAMES_LANG(): string {
    return 'LANG00134';
  }
}
